import { render, staticRenderFns } from "./SubmitOrder.vue?vue&type=template&id=74c04d9c&scoped=true&"
import script from "./SubmitOrder.vue?vue&type=script&lang=js&"
export * from "./SubmitOrder.vue?vue&type=script&lang=js&"
import style0 from "./SubmitOrder.vue?vue&type=style&index=0&id=74c04d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c04d9c",
  null
  
)

export default component.exports